import LevelButton from './LevelButton'
import RemoveButton from './RemoveButton'

const Authorization = ({ authorization, elementId }) => {
  const { id, user, value } = authorization

  return (
    <div className="flex flex-row gap-1 p-3" key={user.id} role="listitem">
      <div className="flex flex-row gap-2 flex-grow">
        <img
          alt={user.name}
          className="h-10 w-10 rounded-md"
          src={user.picture}
        />
        <div className="flex flex-col my-auto text-sm text-gray-600">
          <div className="font-medium">{user.name}</div>
          <div>{user.email}</div>
        </div>
      </div>
      <LevelButton id={elementId} level={value} user={user.id} />
      <RemoveButton id={id} />
    </div>
  )
}

export default Authorization
